import React, { useState } from "react";
import { Box, makeStyles, Typography } from "@material-ui/core";
import { ArrowDropDown, ArrowDropUp } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
    helpText: {
        fontSize: 12,
        letterSpacing: '0.4px',
        color: 'rgba(26, 26, 26, 0.60)',
        textOverflow: 'ellipsis',
        textAlign: 'center',
    },
    helpContent: {
        display: 'flex',
        justifyContent: 'center',
        gap: '12px',
        alignItems: 'center',
    },
    helpContentIcon: {
        cursor: 'pointer',
    },
    sac: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        marginLeft: theme.spacing(4),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
    },
    sacTitle: {
        fontSize: 14,
        fontWeight: 700,
        color: '#323232',
    },
}));

export const HelpContent = ({ helpText }) => {
    const [isOpenSac, setIsOpenSac] = useState(false);

    const classes = useStyles();

    return (
        <>
            <Box className={classes.helpContent}>
                <span className={classes.helpText}>{helpText}</span>
                {isOpenSac
                    ? <ArrowDropUp size="small" className={classes.helpContentIcon} onClick={() => setIsOpenSac(false)} />
                    : <ArrowDropDown size="small" className={classes.helpContentIcon} onClick={() => setIsOpenSac(true)} />
                }
            </Box>
            {isOpenSac && <Box className={classes.sac}>
                <span className={classes.sacTitle}>WhatsApp: (11) 99149-2204</span>
                <Typography variant="body2">Segunda a Sexta, das 09h às 21h  Sábado, das 09h as 19h.</Typography>
            </Box>}
        </>
    );
};